import { useCallback } from 'react';
import useFetchFormWithDraft from './useFetchFormWithDraft';
export default function useGetFormMetadata(formGuid) {
  const {
    data
  } = useFetchFormWithDraft(formGuid);
  return useCallback(key => {
    if (!data || !data.form || !data.form.metaData) {
      return '';
    }
    const metadataEmbed = data.form.metaData.find(metadata => metadata.name === key);
    return metadataEmbed ? metadataEmbed.value : '';
  }, [data]);
}